export default __webpack_public_path__ + "BoxWarningLine.svg?faf250dff983f0ce949a13fd2b05086e";